/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PortalRequest interface.
 */
export function instanceOfPortalRequest(value) {
    if (!('returnUrl' in value) || value['returnUrl'] === undefined)
        return false;
    return true;
}
export function PortalRequestFromJSON(json) {
    return PortalRequestFromJSONTyped(json, false);
}
export function PortalRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'returnUrl': json['return_url'],
    };
}
export function PortalRequestToJSON(json) {
    return PortalRequestToJSONTyped(json, false);
}
export function PortalRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'return_url': value['returnUrl'],
    };
}
